import React from 'react';

// Brand info

const FooterBrand = (): JSX.Element => (
  <div className="footer-brand">
    <div className="footer-brandHeader">
      <span
        className="footer-brandLogoSolid"
        role="img"
        aria-label="Wildcard logo"
      />
      <span className="footer-brandName">WildcardCorp</span>
    </div>

    <p className="footer-brandText">
      We are a team-driven &amp; customer focused technology company with extensive experience in development, hosting, &amp; security.
    </p>

    <br />

    <div className="footer-brandMeta">
      <div className="footer-muted">
        <a className="footer-phone" href="tel:+17158693440">
          (715) 869-3440
        </a>
        &nbsp;&nbsp;|&nbsp;&nbsp;
        <a className="footer-email" href="mailto:info@wildcardcorp.com">
          info@wildcardcorp.com
        </a>
      </div>
    </div>
  </div>
);

export default FooterBrand;
